import React, { useCallback } from "react";
import client from "@culturehq/client";
import { Button } from "@culturehq/components";

import { select, Trans } from "app/utils";

import { RecognitionTypeThumbnailImage } from "components/recognitions/RecognitionTypeImage";
import ChqModalConfirmDelete from "components/common/ChqModalConfirmDelete";
import RecognitionTypeModal from "./RecognitionTypeModal";

const RecognitionTypeRow = ({ recognitionType, onUpdate, onDelete }) => {
  const onConfirmDelete = useCallback(
    async () => {
      await client.deleteRecognitionType({
        recognitionTypeId: recognitionType.id
      });

      onDelete(recognitionType);
    },
    [recognitionType, onDelete]
  );

  const privileges = select(recognitionType.approval, {
    admin_only: "Admin only - only admins may use this recognition type.",
    approval_needed: "Admin approval - admins must approve recognitions of this type that are created before they are published.",
    no_approval_needed: "Open - anyone can use this recognition type."
  });

  return (
    <tr>
      <td>
        <RecognitionTypeThumbnailImage recognitionType={recognitionType} />
      </td>
      <td>
        {recognitionType.name}
      </td>
      <td>
        {recognitionType.points}
      </td>
      <td>
        {privileges}
      </td>
      <td className="Actions-column">
        <RecognitionTypeModal recognitionType={recognitionType} onUpdate={onUpdate}>
          {onTrigger => (
            <Button icon="edit-outlined" onClick={onTrigger} inverted />
          )}
        </RecognitionTypeModal>
        <ChqModalConfirmDelete
          onAccept={onConfirmDelete}
          trigger={onTrigger => (
            <Button icon="trash-a-outlined" onClick={onTrigger} inverted />
          )}
        >
          <Trans>
            Are you sure you would like to delete this recognition type? The
            currently associated recognitions will not be affected.
          </Trans>
        </ChqModalConfirmDelete>
      </td>
    </tr>
  );
};

export default RecognitionTypeRow;
